import React from 'react';
import { cenarios, comoFunciona, cenariosBridge, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight, XCircle, CheckCircle2 } from 'lucide-react';

const CenariosSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4 whitespace-pre-line">
            <span className="text-[#24293f]">{comoFunciona.title}</span>
          </h2>
        </div>

        {/* Como Funciona Cards */}
        <div className="grid md:grid-cols-4 gap-8 mb-24 relative">
          {comoFunciona.steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Card */}
              <div className="h-full bg-[#24293f] rounded-2xl p-6 shadow-xl shadow-blue-900/10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col">

                {/* Header (Icon/Number + Title) */}
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-blue-500/20 border border-blue-400/30 flex items-center justify-center flex-shrink-0 text-blue-300 font-bold text-lg">
                    {step.number}
                  </div>
                  <h3 className="text-white font-semibold text-lg leading-tight">
                    {step.title}
                  </h3>
                </div>

                {/* Description */}
                <p className="text-gray-300 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Arrow Connector (Desktop only, not on last item) */}
              {index < comoFunciona.steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-6 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-6 h-6 text-blue-900/40" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bridge Text */}
        <div className="text-center mb-16">
          <p className="text-2xl font-bold text-neutral-800">
            {cenariosBridge.text}
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">

          {/* Cenario 1 - Red */}
          <div className="group relative bg-[#451a1a] rounded-2xl overflow-hidden border border-red-900/50 hover:border-red-500/50 transition-colors duration-300">
            {/* Header */}
            <div className="bg-red-900/30 p-8 border-b border-red-900/30 min-h-[140px] flex items-center">
              <div className="flex items-start gap-4">
                <div className="mt-1">
                  <div className="w-8 h-8 rounded-full bg-red-900/50 border border-red-500/30 flex items-center justify-center flex-shrink-0">
                    <XCircle className="w-5 h-5 text-red-500" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-white leading-relaxed">
                  {cenarios.cenario1.title}
                </h3>
              </div>
            </div>

            <div className="p-8">
              <ul className="space-y-6">
                {cenarios.cenario1.items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 text-red-100/90 leading-relaxed">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Cenario 2 - Green */}
          <div className="group relative bg-[#1a382e] rounded-2xl overflow-hidden border border-emerald-900/50 hover:border-emerald-500/50 transition-colors duration-300">
            {/* Header */}
            <div className="bg-emerald-900/30 p-8 border-b border-emerald-900/30 min-h-[140px] flex items-center">
              <div className="flex items-start gap-4">
                <div className="mt-1">
                  <div className="w-8 h-8 rounded-full bg-emerald-900/50 border border-emerald-500/30 flex items-center justify-center flex-shrink-0">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-white leading-relaxed">
                  {cenarios.cenario2.title}
                </h3>
              </div>
            </div>

            <div className="p-8">
              <ul className="space-y-6">
                {cenarios.cenario2.items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 text-emerald-100/90 leading-relaxed">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-5 py-3 text-sm md:px-8 md:py-4 md:text-lg rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25">

            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CenariosSection;